export const ITEMS_HAS_ERRORED = 'ITEMS_HAS_ERRORED';
export const ITEMS_IS_LOADING = 'ITEMS_IS_LOADING';
export const ITEMS_FETCH_DATA_SUCCESS = 'ITEMS_FETCH_DATA_SUCCESS';

export const CASE1_UPDATE_SLIDER = 'CASE1_UPDATE_SLIDER';
export const CASE1_FETCH_DATA_SUCCESS = 'ITEMS_CASE1_FETCH_DATA_SUCCESS';

export const CASE2_UPDATE_SLIDER = 'CASE2_UPDATE_SLIDER';
export const CASE2_FETCH_DATA_SUCCESS = 'CASE2_FETCH_DATA_SUCCESS';
export const CASE2_ADJINF_FETCH_DATA_SUCCESS = 'CASE2_ADJINF_FETCH_DATA_SUCCESS';
export const CASE2_NOTADJINF_FETCH_DATA_SUCCESS = 'CASE2_NOTADJINF_FETCH_DATA_SUCCESS';

export const CASE3_UPDATE_SLIDER = 'CASE3_UPDATE_SLIDER';
export const CASE3_WITHINTEREST_FETCH_DATA_SUCCESS = 'CASE3_WITHINTEREST_FETCH_DATA_SUCCESS';
export const CASE3_WITHOUTINTEREST_FETCH_DATA_SUCCESS = 'CASE3_WITHOUTINTEREST_FETCH_DATA_SUCCESS';
export const CASE3_PMTS_FETCH_DATA_SUCCESS = 'CASE3_PMTS_FETCH_DATA_SUCCESS';


export const CASE4_UPDATE_SLIDER = 'CASE4_UPDATE_SLIDER';
export const CASE4_ADJINF_FETCH_DATA_SUCCESS = 'CASE4_ADJINF_FETCH_DATA_SUCCESS';
export const CASE4_NOTADJINF_FETCH_DATA_SUCCESS = 'CASE4_NOTADJINF_FETCH_DATA_SUCCESS';
export const CASE4_WITHOUTINTEREST_FETCH_DATA_SUCCESS = 'CASE4_WITHOUTINTEREST_FETCH_DATA_SUCCESS';
export const CASE4_PMTS_FETCH_DATA_SUCCESS = 'CASE4_PMTS_FETCH_DATA_SUCCESS';

export const CASE5_PMTS_FETCH_DATA_SUCCESS = 'CASE5_PMTS_FETCH_DATA_SUCCESS';
export const CASE5_UPDATE_SLIDER = 'CASE5_UPDATE_SLIDER';
export const CASE5_FV_NOTADJINFLATION_FETCH_DATA_SUCCESS = 'CASE5_FV_NOTADJINFLATION_FETCH_DATA_SUCCESS';
export const CASE5_FV_ADJINFLATION_FETCH_DATA_SUCCESS = 'CASE5_FV_ADJINFLATION_FETCH_DATA_SUCCESS';
export const CASE5_PMT_WITHINTEREST_FETCH_DATA_SUCCESS = 'CASE5_PMT_WITHINTEREST_FETCH_DATA_SUCCESS';
export const CASE5_PV_REAL_FETCH_DATA_SUCCESS = 'CASE5_PV_REAL_FETCH_DATA_SUCCESS';
//export const CASE5_TOTAL_WITHOUTINTEREST_FETCH_DATA_SUCCESS = 'CASE5_TOTAL_WITHOUTINTEREST_FETCH_DATA_SUCCESS';

export const CASE6_UPDATE_SLIDER = 'CASE6_UPDATE_SLIDER';
export const CASE6_SPENDING_REQUIRED_FETCH_DATA_SUCCESS = 'CASE6_SPENDING_REQUIRED_FETCH_DATA_SUCCESS';
export const CASE6_SPENDING_WITHOUTINTEREST_FETCH_DATA_SUCCESS = 'CASE6_SPENDING_WITHOUTINTEREST_FETCH_DATA_SUCCESS';

export const CASE7_UPDATE_SLIDER = 'CASE7_UPDATE_SLIDER';
export const CASE7_SPENDING_REQUIRED_NOTADJINFLATION_FETCH_DATA_SUCCESS = 'CASE7_SPENDING_REQUIRED_NOTADJINFLATION_FETCH_DATA_SUCCESS';

export const CASE8_UPDATE_SLIDER = 'CASE8_UPDATE_SLIDER';
export const CASE8_FETCH_DATA_SUCCESS = 'CASE8_FETCH_DATA_SUCCESS';

export const CASE9_UPDATE_SLIDER = 'CASE9_UPDATE_SLIDER';
export const CASE9_FETCH_DATA_SUCCESS = 'CASE9_FETCH_DATA_SUCCESS';

export const ADD1_UPDATE_SLIDER = 'ADD1_UPDATE_SLIDER';
export const ADD1_FETCH_DATA_SUCCESS = 'ADD1_FETCH_DATA_SUCCESS';

export const ADD2_UPDATE_SLIDER = 'ADD2_UPDATE_SLIDER';
export const ADD2_FETCH_DATA_SUCCESS = 'ADD2_FETCH_DATA_SUCCESS';

export const ADD3_UPDATE_SLIDER = 'ADD3_UPDATE_SLIDER';
export const ADD3_FETCH_DATA_SUCCESS = 'ADD3_FETCH_DATA_SUCCESS';

export const ADD4_UPDATE_SLIDER = 'ADD4_UPDATE_SLIDER';
export const ADD4_FETCH_DATA_SUCCESS = 'ADD4_FETCH_DATA_SUCCESS';



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js